// extracted by mini-css-extract-plugin
module.exports = {"faqHeader":"FAQHeader_faqHeader__3Dc00","faqItemTitle":"FAQHeader_faqItemTitle__P8owi","accordionButton":"FAQHeader_accordionButton__B_tJK","closed":"FAQHeader_closed__y2_7C"};